import React, { useEffect, useState, useMemo } from 'react';
import { message, Modal, Button, Spin } from 'antd';
import { FiltersComponentAntd } from './NovedadesParticipanteFilter';
import NovedadViewModal from "./NovedadesParticipanteView"
import NovedadFormAntd from './NovedadesParticipanteForm';
import NovedadesTable from './NovedadesParticipanteTable';
import { createNovedad, deleteNovedad, updateNovedad, getDepartamentos, getMunicipios, getParticipantes, getAllNovedades, getParticipantesEditar, getProyectos, getAllProyectos } from '../../services/novedad_participante/novedadParticipanteService';
import { selectAppPermissions } from '../../store/auth/selectors';
import ExportExcelButton from './NovedadesExportable';
import { useSelector } from 'react-redux';

const NovedadesPage = ({ proyectoCodigo }) => {
   const proyectoId = proyectoCodigo? Number(proyectoCodigo.replace(/^P/, '')): null;
  const [novedades, setNovedades] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [novedadEditando, setNovedadEditando] = useState(null);
  const [listaPartiEditar, setListaPartEditar] = useState(null);
  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const [modalVisualizacion, setModalVisualizacion] = useState(false)
  const [novedadVisualizando, setNovedadVisualizando] = useState(null);
  const [loadingPage, setLoadingPage] = useState(false);
  const [proyectosForm, setProyectosForm] = useState([]);
  const appName = 'novedad_participante';
  const permissions = useSelector((state) => selectAppPermissions(state, appName));
  const permissionDelete = permissions.priv_delete === 'Y';
  const permissionUpdate = permissions.priv_update === 'Y';
  const permissionInsert = permissions.priv_insert === 'Y';
  const permissionPrint = permissions.priv_print === 'Y';
  const permissionExport = permissions.priv_export === 'Y';
  const user = useSelector((state) => state.auth.user);
  const userLogin = user.username;

const [filters, setFilters] = useState({
  texto: '',
  departamento: '0',
  municipio: '0',
  tipoNovedad: '0',
  proyecto: proyectoId ? String(proyectoId) : '0',
});
  const [opcionesFiltros, setOpcionesFiltros] = useState({
    departamentos: [],
    municipios: [],
    tiposNovedad: [],
    proyectos: [],
  });

  useEffect(() => {
  if (proyectoId) {
    setFilters(prev => ({
      ...prev,
      proyecto: String(proyectoId)
    }));
  }
}, [proyectoId])

  const fetchInitialData = async () => {
  setLoadingPage(true);
  try {
    const [
      dataNovedad,
      dataDepartamento,
      dataMunicipio,
      dataProyectosFiltro,
      dataProyectosForm
    ] = await Promise.all([
      getAllNovedades(),
      getDepartamentos(),
      getMunicipios(),
      getProyectos(),
      getAllProyectos()
    ]);

    setDepartamentos(dataDepartamento);
    setMunicipios(dataMunicipio);
    setNovedades(dataNovedad); // 👈 SOLO ESTO
    setProyectosForm(dataProyectosForm);
    cargarOpciones(dataNovedad, dataProyectosFiltro);

  } catch (error) {
    message.error('Error al cargar los datos iniciales');
  } finally {
    setLoadingPage(false);
  }
};

  const fetchParticipantes = async () => {
    try {
      const data = await getParticipantes();
      setParticipantes(data);
    } catch (error) {
      message.error('Error al cargar los participantes');
    }
  };

  useEffect(() => {
    fetchInitialData();
    fetchParticipantes(); 
  }, []);


  const participantesEditar = async (participanteId) => {
    try {
      const data = await getParticipantesEditar(participanteId);
      setListaPartEditar(data);
    } catch (error) {
      message.error("Error al cargar los participantes");
    }
  };

  const refreshNovedades = async () => {
  setLoadingPage(true);
  try {
    const [dataNovedad, dataProyectosFiltro] = await Promise.all([
      getAllNovedades(),
      getProyectos()
    ]);

    setNovedades(dataNovedad); 
    const nuevasOpciones = cargarOpciones(dataNovedad, dataProyectosFiltro);

    setFilters((prev) => ({
      ...prev,
      departamento: nuevasOpciones.departamentos.includes(prev.departamento)
        ? prev.departamento
        : '0',
      municipio: nuevasOpciones.municipios.includes(prev.municipio)
        ? prev.municipio
        : '0',
      proyecto: nuevasOpciones.proyectos.some(
        p => String(p.id) === prev.proyecto
      )
        ? prev.proyecto
        : '0',
    }));

  } catch (error) {
    message.error("Error al recargar novedades");
  } finally {
    setLoadingPage(false);
  }
};
  const cargarOpciones = (dataNovedad, dataProyectos) => {
    const departamentos = [...new Set(dataNovedad.map((n) => n.departamento))];
    const municipios = [...new Set(dataNovedad.map((n) => n.municipio))];
    const tiposNovedad = [...new Set(dataNovedad.map((n) => n.tipo_novedad))];
    const proyectos = dataProyectos.map(p => ({ id: p.oid, nombre: p.proyecto, codigo: p.codigo }));
    const opciones = { departamentos, municipios, tiposNovedad, proyectos };
    setOpcionesFiltros(opciones);
    return opciones;
  };

  const filteredNovedades = useMemo(() => {
  let filtrados = [...novedades];
  const { texto, departamento, municipio, tipoNovedad, proyecto } = filters;

  if (texto) {
    const lowerTexto = texto.toLowerCase();
    filtrados = filtrados.filter((n) => {
      const nombre = n.nombre_participante || "";
      const cedula = n.numero_identificacion || "";
      return (
        nombre.toLowerCase().includes(lowerTexto) ||
        cedula.toLowerCase().includes(lowerTexto)
      );
    });
  }

  if (departamento !== '0') {
    filtrados = filtrados.filter((n) => n.departamento === departamento);
  }

  if (municipio !== '0') {
    filtrados = filtrados.filter((n) => n.municipio === municipio);
  }

  if (tipoNovedad !== '0') {
    filtrados = filtrados.filter(
      (n) => String(n.tipo_novedad) === tipoNovedad
    );
  }

  if (proyecto !== '0') {
    filtrados = filtrados.filter(
      (n) => String(n.id_proyecto) === proyecto
    );
  }

  return filtrados;

}, [filters, novedades]);
  const onUpdateFilter = (key, value) => {
    setFilters((prev) => {
      const nuevosFiltros = { ...prev, [key]: value };
      if (key === "departamento") { nuevosFiltros.municipio = '0'; }
      return nuevosFiltros;
    });
  };

const onLimpiarFiltros = () => {
  setFilters({
    texto: '',
    departamento: '0',
    municipio: '0',
    tipoNovedad: '0',
    proyecto: proyectoId ? String(proyectoId) : '0',
  });
};

  const handleEliminar = async (novedad) => {
    if (!permissionDelete) return message.warning("No tienes permisos para eliminar");
    Modal.confirm({
      title: '¿Estás seguro que deseas eliminar esta novedad?',
      onOk: async () => {
        try {
          await deleteNovedad(novedad.oid, novedad, userLogin);
          message.success('Novedad eliminada correctamente');
          refreshNovedades();
        } catch (err) {
          console.error(err);
          message.error('Error al eliminar la novedad');
        }
      },
    });
  };

  const handleEditar = async (novedad) => {
    setNovedadEditando(novedad);
    await participantesEditar(novedad.participante_oid);
    setFormVisible(true);
  };

  const handleVisualizar = (novedad) => {
    setNovedadVisualizando({
      participante: novedad.nombre_participante,
      cedula: novedad.numero_identificacion,
      proyecto: novedad.nombre_proyecto,
      departamento: novedad.departamento,
      municipio: novedad.municipio,
      tipoNovedad: novedad.tipo_novedad,
      fechaRegistro: novedad.fecha_registro,
      observacion: novedad.observacion,
      estado: novedad.estado,
      reemplazo: novedad.reemplazo,
      estado_remplazo: novedad.estado_remplazo,
      nombre_reemplazo: novedad.nombre_reemplazo,
      soportes: novedad.soportes || [],
      soportes_reemplazo: novedad.soportesRemplazo || []
    });
    setModalVisualizacion(true);
  };

  const guardarNovedad = async (formData) => {
    try {
      const {
        participanteSeleccionado,
        proyectoSeleccionado,
        tipoNovedad,
        observacion,
        participanteCedula,
        estado,
        fecha_registro,
        soportes,
        soportesReemplazo,
        participanteReemplazo,
        estado_remplazo
      } = formData;

      const data = new FormData();
      data.append("participante_oid", participanteSeleccionado);
      data.append("id_proyecto", proyectoSeleccionado);
      data.append("tipo_novedad", tipoNovedad);
      data.append("observacion", observacion);
      data.append("usuario", userLogin);
      data.append("estado", estado ?? '1');
      data.append("fecha_registro", fecha_registro);
      data.append("cedula", participanteCedula);
      data.append("participante_remplazo", participanteReemplazo ?? '');
      data.append("estado_remplazo", estado_remplazo);
      if (Array.isArray(soportes)) {
        soportes.forEach((soporte, index) => {
          if (soporte.archivo) {
            data.append("soportes", soporte.archivo);
            data.append(`estado_${index}`, soporte.estado ?? '1');
            data.append(`soporte_tipo_${index}`, '1');
          }
        });
      }

      if (Array.isArray(soportesReemplazo)) {
        soportesReemplazo.forEach((soporte, index) => {
          if (soporte.archivo) {
            const idx = (soportes?.length ?? 0) + index;
            data.append("soportes", soporte.archivo);
            data.append(`estado_${idx}`, soporte.estado ?? '1');
            data.append(`soporte_tipo_${idx}`, '2');  // <--- soporte = 2
          }
        });
      }
      await createNovedad(data);
      message.success("Novedad guardada exitosamente");
      refreshNovedades();
      return true;
    } catch (error) {
      console.error("Error al guardar novedad:", error);
      message.error("Hubo un error al guardar la novedad");
      return false;
    }
  };

  const handleActualizar = async (formData, oid) => {
    try {
      await updateNovedad(oid, formData);
      message.success("Novedad actualizada correctamente");
      refreshNovedades();
      return true;
    } catch (error) {
      console.error("Error al actualizar:", error);
      message.error("Ocurrió un error al actualizar la novedad.");
      return false;
    }
  };

  return (
    <div className="container">
      <div className="row mb-2 d-flex align-items-center">
        <div className="col-md-7 linea_separador mb-2 d-flex align-items-center">
          <div className="titulo_proyecto" style={{ flexBasis: '25%', flexGrow: 0 }}>
            <p>PROYECTO UTF <br /> COL 160 COL</p>
          </div>
          <div className="objeto" style={{ flexBasis: '75%', flexGrow: 0 }}>
            <p>
              Implementar actividades de desarrollo económico, derecho humano a la alimentación y fortalecimiento de capacidades
              institucionales, comunitarias y organizacionales que aporten al cierre de brechas y la transformación de los territorios PDET
            </p>
          </div>
        </div>
        <div className="col-md-5 d-flex justify-content-center align-items-center flex-column">
          <h4 className="text-center mb-4">Novedades de Participantes</h4>

          <div className="d-flex flex-row gap-2">
            {permissionInsert && (
              <Button type="primary" onClick={() => setFormVisible(true)}>
                + Nueva Novedad
              </Button>
            )}
            {permissionExport && (
              <ExportExcelButton
                novedades={filteredNovedades}
                fileName="novedades_participantes"
              />
            )}
          </div>
        </div>    
      </div>
      <Spin 
  spinning={loadingPage} 
  size="large"
  tip="Procesando información..."
>
      <FiltersComponentAntd
        filters={filters}
        opcionesFiltros={opcionesFiltros}
        totalRegistros={novedades.length}
        registrosFiltrados={filteredNovedades.length}
        onUpdateFilter={onUpdateFilter}
        onLimpiarFiltros={onLimpiarFiltros}
        proyectoBloqueado={proyectoId}
      />
      <NovedadesTable
        novedades={filteredNovedades}
        onEditar={handleEditar}
        onEliminar={handleEliminar}
        onVisualizar={handleVisualizar}
        canEdit={permissionUpdate}
        canDelete={permissionDelete}
        canView={permissionPrint}
      />
      <NovedadFormAntd
        open={formVisible}
        onOpenChange={setFormVisible}
        novedadEditando={novedadEditando}
        onGuardar={(formData) => guardarNovedad(formData)}
        onActualizar={(formData, oid) => handleActualizar(formData, oid)}
        onCancelar={() => {
          setNovedadEditando(null);
        }}
        departamentos={departamentos}
        municipios={municipios}
        participantes={novedadEditando ? listaPartiEditar || [] : participantes}
        userLogin={userLogin}
        onSuccess={fetchParticipantes}
        cargarParticipantes={fetchParticipantes}
        proyectos={proyectosForm}
      />
      <NovedadViewModal open={modalVisualizacion} onOpenChange={setModalVisualizacion} novedad={novedadVisualizando} />
      </Spin>
    </div>
  );
};

export default NovedadesPage;
